import { TInitialState, TPopupGroupState } from '~/src/components/ConnectDomruPopup/context/initialState';

export const getView = (state: TInitialState): TPopupGroupState => state.view;
